import React from "react"
import styled from "styled-components"

import { LinkWithIcon as _LinkWithIcon } from "components/text"
import { Flex } from "components/box"

import { baseRoutes } from "routes"

const LinkWithIcon = styled(_LinkWithIcon)`
  display: inline-flex;
  flex-basis: 50%;
  justify-content: center;
  align-items: center;

  &:last-child {
    border-right: none;
  }

  padding: ${props => props.theme.space[5]} 0;
  border-right: 1px solid ${props => props.theme.colors.lightTeal};
`

interface ToolbarProps {
  doctorExists?: boolean
}

const Toolbar: React.FC<ToolbarProps> = ({ doctorExists }) => (
  <Flex bg="paleAqua">
    {doctorExists && (
      <LinkWithIcon to={baseRoutes.doctorMessaging()} iconName="message" iconPosition="left">
        Message doctor
      </LinkWithIcon>
    )}
    <LinkWithIcon to={baseRoutes.migraineEventsNew()} iconName="plus" iconPosition="left">
      Add event
    </LinkWithIcon>
  </Flex>
)

export default Toolbar
